import { RenderedSpecialCondition } from '@urbanx/agx.campaigns.client'
import { DropdownOption } from '@urbanx/agx.ui-components2'
import { useMemo } from 'react'

const truncateText = (text: string | undefined, maxLength = 50): string => {
  const str = text || ''
  return str.length > maxLength ? `${str.substring(0, maxLength)}...` : str
}

export const useSpecialConditionsOptions = (
  renderedSpecialConditions: RenderedSpecialCondition[] | undefined
) => {
  return useMemo(() => {
    return [
      { label: '-', value: '' },
      ...((renderedSpecialConditions?.flatMap((condition) => {
        return [
          {
            label: `Clause ${condition.position}: ${truncateText(condition.title)}`,
            value: condition.id ?? '',
          },
          ...(condition.clauses?.map((clause) => ({
            label: `Clause ${clause.clausePosition}: ${truncateText(clause.clauseText)}`,
            value: clause.clauseId ?? '',
          })) ?? []),
        ]
      }) as DropdownOption[]) ?? []),
    ]
  }, [renderedSpecialConditions])
}
